// extracted by mini-css-extract-plugin
module.exports = {"flexContainer":"styles_flexContainer__Ceyp_","image":"styles_image__1zlI1","review":"styles_review__3zAkc","message":"styles_message__3h9CW"};